import {
  fetchRefreshedTokens,
  type CognitoRefreshResponse,
} from '../../cognito/refreshTokens';

export type RefreshSessionResult =
  | { ok: true; accessToken: string; idToken: string }
  | { ok: false; reason: 'missing' | 'network' | 'invalid' };

export const refreshSession = async (
  refreshToken: string | null,
  apiEnv: string
): Promise<RefreshSessionResult> => {
  if (!refreshToken) return { ok: false, reason: 'missing' };

  const { response, error } = await fetchRefreshedTokens(refreshToken, apiEnv);

  if (error) return { ok: false, reason: 'network' };

  if (isInvalidRefreshResponse(response))
    return { ok: false, reason: 'invalid' };

  return {
    ok: true,
    accessToken: response.AuthenticationResult.AccessToken,
    idToken: response.AuthenticationResult.IdToken,
  };
};

export const isInvalidRefreshResponse = (
  response?: CognitoRefreshResponse | null
): boolean => {
  return Boolean(
    !response?.AuthenticationResult || response.__type !== undefined
  );
};
